import {Endpoint} from '../util';
import {useQuery} from './useEndpoint';

export function useTraitEligibility() {
    const {
        data: currentUserTraitEligibility = [],
        error,
        isError,
        isPending,
    } = useQuery({endpoint: Endpoint.TRAIT_ELIGIBILITY});

    const eligibleTraits = currentUserTraitEligibility?.filter(({eligible}) => eligible === true);
    const ineligibleTraits = currentUserTraitEligibility?.filter(({eligible}) => eligible === false);

    return {
        eligibleTraits,
        error,
        ineligibleTraits,
        isError,
        isPending,
    };
}
